import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { logout } from "../../reducers/usersReducer";

const LogoutPage: React.FC = () => {
//   const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // Assuming you have some logout functionality here
    // Clear user session or perform any necessary cleanup

    // Redirect to the login page after logout
    dispatch(logout());
    // navigate('/login');
  };

  // Immediately invoke handleLogout when the component mounts
  React.useEffect(() => {
    handleLogout();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null; // Or you can return a loading indicator or message here
};

export default LogoutPage;